import styled from "styled-components";

import { fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

const OffCanvasTrayHeaderTitle = styled.h5`
  font-family: ${fonts.fontInterstateUltraBlack};
  font-size: 20px;
  line-height: 1;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin: 0;
  ${breakpoints.smUp} {
    display: none;
  }
`;

export default OffCanvasTrayHeaderTitle;
